import { render, staticRenderFns } from "./guiding.vue?vue&type=template&id=f63d3434&scoped=true"
import script from "./guiding.vue?vue&type=script&lang=js"
export * from "./guiding.vue?vue&type=script&lang=js"
import style0 from "./guiding.vue?vue&type=style&index=0&id=f63d3434&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d3434",
  null
  
)

export default component.exports